import React from 'react';
import { Box, Typography } from '@mui/material';

const bannerSx = {
  borderRadius: 2,
  border: '2px solid #66bb6a',
  background: 'linear-gradient(180deg, #e8f5e9 0%, #f1f8e9 100%)',
  boxShadow: '0 8px 24px rgba(46, 125, 50, 0.16)',
  px: 2.5,
  py: 1.5,
  textAlign: 'center',
};

const textSx = {
  color: '#2e7d32',
  fontWeight: 700,
  fontSize: { xs: '0.9rem', md: '0.98rem' },
  lineHeight: 1.45,
};

function formatAnnouncementDisplayText(message) {
  const text = (message || '').trim();
  if (!text) return '';
  return /^important info:/i.test(text) ? text : `Important info: ${text}`;
}

export function MarketAnnouncementBanner({ message, sx, maxWidth = 720 }) {
  const display = formatAnnouncementDisplayText(message);
  if (!display) return null;
  return (
    <Box sx={{ maxWidth, width: '100%', mx: 'auto', ...bannerSx, ...sx }}>
      <Typography variant="body1" sx={textSx}>
        {display}
      </Typography>
    </Box>
  );
}

export function MarketAnnouncementBannerList({ messages, sx, maxWidth = 720, stackGap = 1.5 }) {
  const list = (messages || []).map((m) => (m || '').trim()).filter(Boolean);
  if (!list.length) return null;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: stackGap, width: '100%', alignItems: 'center' }}>
      {list.map((message, idx) => (
        <MarketAnnouncementBanner key={`${idx}-${message.slice(0, 24)}`} message={message} sx={sx} maxWidth={maxWidth} />
      ))}
    </Box>
  );
}

export default MarketAnnouncementBanner;
